// ----------------------------------------------------------------------------
// Section: Shop Carousel
// ----------------------------------------------------------------------------
//
// Tabbed product carousel with manual product selection
// - Desktop & Mobile: Horizontal tabs with content switching
// - Max 3 tabs/categories
// - Max 4 products per tab
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';

// Styles
import './_shop-carousel.scss';

// -------------------------------------
// Variables
// -------------------------------------

const BUTTONS_CONTAINER = '.shop-carousel__tabs-buttons';
const CONTENT_WRAPPER = '.shop-carousel__tabs-content-wrapper';
const BUTTON = '.shop-carousel__tab-button';
const CONTENT = '.shop-carousel__tab-content';
const OPEN_CLASS = 'is-open';

// -------------------------------------
// Initialization
// -------------------------------------

$(document).ready(function() {
    // Initialize each carousel instance separately
    $('.shop-carousel__wrapper').each(function() {
        const $carousel = $(this);
        const $buttonsContainer = $carousel.find(BUTTONS_CONTAINER);
        const $contentWrapper = $carousel.find(CONTENT_WRAPPER);

        if ($buttonsContainer.length && $contentWrapper.length) {
            const $buttons = $buttonsContainer.find(BUTTON);
            const $content = $contentWrapper.find(CONTENT);
            const $firstButton = $buttons.first();

            // Open first tab
            if ($firstButton.length) {
                $firstButton.addClass(OPEN_CLASS);
                $firstButton.attr('aria-selected', 'true');
                $firstButton.attr('tabindex', '0');

                const firstContentId = $firstButton.attr('aria-controls');
                const $firstContent = $('#' + firstContentId);
                $firstContent.addClass(OPEN_CLASS);
                $firstContent.attr('hidden', false);

                // Set other tabs as not selected and hidden
                $buttons.not($firstButton).attr('tabindex', '-1');
                $content.not($firstContent).attr('hidden', true);
            }

            // Tab click handler - scoped to this carousel instance
            $buttons.on('click', function(e) {
                e.preventDefault();
                const $button = $(this);
                const $buttonsInCarousel = $carousel.find(BUTTONS_CONTAINER);
                const $contentInCarousel = $carousel.find(CONTENT_WRAPPER);
                const $allButtons = $buttonsInCarousel.find(BUTTON);
                const $allContent = $contentInCarousel.find(CONTENT);
                const contentId = $button.attr('aria-controls');
                const $targetContent = $('#' + contentId);

                // Close all tabs in this carousel
                $allButtons.removeClass(OPEN_CLASS);
                $allButtons.attr('aria-selected', 'false');
                $allButtons.attr('tabindex', '-1');
                $allContent.removeClass(OPEN_CLASS);
                $allContent.attr('hidden', true);

                // Open selected tab
                $button.addClass(OPEN_CLASS);
                $button.attr('aria-selected', 'true');
                $button.attr('tabindex', '0');
                $targetContent.addClass(OPEN_CLASS);
                $targetContent.attr('hidden', false);
            });

            // Keyboard navigation - scoped to this carousel instance
            $buttons.on('keydown', function(e) {
                const key = e.which;
                const currentIndex = $buttons.index(e.target);
                let newIndex;

                switch(key) {
                    case 37: // Left arrow
                    case 38: // Up arrow
                        e.preventDefault();
                        newIndex = currentIndex > 0 ? currentIndex - 1 : $buttons.length - 1;
                        $buttons.eq(newIndex).trigger('click');
                        $buttons.eq(newIndex).focus();
                        break;
                    case 39: // Right arrow
                    case 40: // Down arrow
                        e.preventDefault();
                        newIndex = currentIndex < $buttons.length - 1 ? currentIndex + 1 : 0;
                        $buttons.eq(newIndex).trigger('click');
                        $buttons.eq(newIndex).focus();
                        break;
                    case 36: // Home
                        e.preventDefault();
                        $buttons.first().trigger('click');
                        $buttons.first().focus();
                        break;
                    case 35: // End
                        e.preventDefault();
                        $buttons.last().trigger('click');
                        $buttons.last().focus();
                        break;
                }
            });
        }
    });

    console.log('Shop Carousel initialized');
});

